/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CheckRule } from './checkRule';
import { SharedProjectDto } from './sharedProjectDto';

export interface CheckRuleSet { 
    id?: string;
    name?: string;
    description?: string;
    type?: CheckRuleSet.TypeEnum;
    prebuilt?: boolean;
    projectId?: number;
    configJson?: string;
    status?: CheckRuleSet.StatusEnum;
    version?: number;
    publishedId?: string;
    rules?: Array<CheckRule>;
    createdAt?: Date;
    updatedAt?: Date;
    sharedProjects?: Array<SharedProjectDto>;
}
export namespace CheckRuleSet {
    export type TypeEnum = 'KI' | 'HYBRID' | 'IDS' | 'CROSS';
    export const TypeEnum = {
        KI: 'KI' as TypeEnum,
        HYBRID: 'HYBRID' as TypeEnum,
        IDS: 'IDS' as TypeEnum,
        CROSS: 'CROSS' as TypeEnum
    };
    export type StatusEnum = 'DRAFT' | 'PUBLISHED' | 'ARCHIVED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        PUBLISHED: 'PUBLISHED' as StatusEnum,
        ARCHIVED: 'ARCHIVED' as StatusEnum
    };
}